import Joi from 'joi';

export interface IReportEntry {
  name: string;
  query: string;
}

export interface IEntriesResponse {
  [key: string]: IReportEntry[] | undefined;
}

export const reportEntrySchema = Joi.object({
  name: Joi.string().required(),
  query: Joi.string().required(),
});

export const entriesResponseSchema = Joi.object().pattern(
  Joi.string().required(),
  Joi.array().items(reportEntrySchema)
);
